// JS file for Contact

import '@main';

const form = '#contact-form';

u.formValidation()
  .then(() => {
    u.$ui.disableOnSubmit(form);
  });

function onSubmit(token) {
  $('.g-recaptcha').attr('disabled', true);
  document.getElementById('contact-form').submit();
}

window.onSubmit = onSubmit;
